<template>
    <div class="p-grid p-fluid">
        <div class="p-col-12">
            <div class="p-formgroup-inline">
                <div class="p-field">
                    <Button label="Hoje" class="p-button-primary p-mr-2" 
                        icon="pi pi-calendar" @click="selecilecionarHoje"/>
                </div>                    
                <div class="p-field">
                    <Button label="Resumo" class="p-button-primary p-mr-2" 
                        icon="pi pi-align-justify" @click="selecionarResumo" v-if="temResumoHoras"/>         
                </div>   
                <div class="p-field">
                    <Button label="Baixar Comprovantes" class="p-button-primary p-mr-2" 
                        icon="pi pi-download" @click="exibirDownloadComprovantes"/>         
                </div>           
                <div class="p-field">
                    <div class="p-inputgroup">
                        <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :manualInput="false" 
                        :showIcon="true" :yearNavigator="true" 
                        :yearRange="rangeData" :locale="localeCalendarBR" @date-select="getEspelho"/>                   
                    </div>
                </div>
            </div>                
        </div>
        <div class="p-col-7">       
            <DataTable :value="semanasDoMes" class="p-datatable-sm p-datatable-gridlines" id="espelho">	
                <Column header="Dom">
                    <template #body="slotProps">
                        <div @click="selecionarDia(slotProps.data.dom)"> 
                            <div style="height: 40px;" 
                                :class="getClassStatusDia(slotProps.data.dom)">
                                {{ slotProps.data.dom.dia }}
                            </div>	
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.dom.selecionado ? 'div-selecionada' : ''"
                                v-if="slotProps.data.dom.ponto">
                                <i class="pi pi-clock p-mr-1" 
                                    v-for="m in slotProps.data.dom.ponto.marcacoes" 
                                    :key="m.index" :title="m.dataHora"></i>
                            </div>		
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.dom.selecionado ? 'div-selecionada' : ''"
                                v-else></div>	
                        </div>
                    </template>
                </Column>
                <Column header="Seg">
                    <template #body="slotProps">
                        <div @click="selecionarDia(slotProps.data.seg)">                      
                            <div style="height: 40px;" 
                                :class="getClassStatusDia(slotProps.data.seg)">
                                {{ slotProps.data.seg.dia }}
                            </div>	
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.seg.selecionado ? 'div-selecionada' : ''"
                                v-if="slotProps.data.seg.ponto">
                                <i class="pi pi-clock p-mr-1" 
                                    v-for="m in slotProps.data.seg.ponto.marcacoes" 
                                    :key="m.index" :title="m.dataHora"></i>
                            </div>		
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.seg.selecionado ? 'div-selecionada' : ''"
                                v-else></div>
                        </div>                        
                    </template>
                </Column>
                <Column header="Ter">
                    <template #body="slotProps">
                        <div @click="selecionarDia(slotProps.data.ter)"> 
                            <div style="height: 40px;" 
                                :class="getClassStatusDia(slotProps.data.ter)">
                                {{ slotProps.data.ter.dia }}
                            </div>	
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.ter.selecionado ? 'div-selecionada' : ''"
                                v-if="slotProps.data.ter.ponto">
                                <i class="pi pi-clock p-mr-1" 
                                    v-for="m in slotProps.data.ter.ponto.marcacoes" 
                                    :key="m.index" :title="m.dataHora"></i>
                            </div>		
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.ter.selecionado ? 'div-selecionada' : ''"
                                v-else></div>	
                        </div>			
                    </template>
                </Column>
                <Column header="Qua">
                    <template #body="slotProps">
                        <div @click="selecionarDia(slotProps.data.qua)"> 
                            <div style="height: 40px;" 
                                :class="getClassStatusDia(slotProps.data.qua)">
                                {{ slotProps.data.qua.dia }}
                            </div>	
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.qua.selecionado ? 'div-selecionada' : ''"
                                v-if="slotProps.data.qua.ponto">
                                <i class="pi pi-clock p-mr-1" 
                                    v-for="m in slotProps.data.qua.ponto.marcacoes" 
                                    :key="m.index" :title="m.dataHora"></i>
                            </div>		
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.qua.selecionado ? 'div-selecionada' : ''"
                                v-else></div>	
                        </div>			
                    </template>
                </Column>
                <Column header="Qui">
                    <template #body="slotProps">
                        <div @click="selecionarDia(slotProps.data.qui)"> 
                            <div style="height: 40px;" 
                                :class="getClassStatusDia(slotProps.data.qui)">
                                {{ slotProps.data.qui.dia }}
                            </div>	
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.qui.selecionado ? 'div-selecionada' : ''"
                                v-if="slotProps.data.qui.ponto">
                                <i class="pi pi-clock p-mr-1" 
                                    v-for="m in slotProps.data.qui.ponto.marcacoes" 
                                    :key="m.index" :title="m.dataHora"></i>
                            </div>		
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.qui.selecionado ? 'div-selecionada' : ''"
                                v-else></div>	
                        </div>			
                    </template>
                </Column>
                <Column header="Sex">
                    <template #body="slotProps">
                        <div @click="selecionarDia(slotProps.data.sex)"> 
                            <div style="height: 40px;" 
                                :class="getClassStatusDia(slotProps.data.sex)">
                                {{ slotProps.data.sex.dia }}
                            </div>	
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.sex.selecionado ? 'div-selecionada' : ''"
                                v-if="slotProps.data.sex.ponto">
                                <i class="pi pi-clock p-mr-1" 
                                    v-for="m in slotProps.data.sex.ponto.marcacoes" 
                                    :key="m.index" :title="m.dataHora"></i>
                            </div>		
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.sex.selecionado ? 'div-selecionada' : ''"
                                v-else></div>	
                        </div>			
                    </template>
                </Column>
                <Column header="Sáb">
                    <template #body="slotProps">
                        <div @click="selecionarDia(slotProps.data.sab)"> 
                            <div style="height: 40px;" 
                                :class="getClassStatusDia(slotProps.data.sab)">
                                {{ slotProps.data.sab.dia }}
                            </div>	
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.sab.selecionado ? 'div-selecionada' : ''"
                                v-if="slotProps.data.sab.ponto">
                                <i class="pi pi-clock p-mr-1" 
                                    v-for="m in slotProps.data.sab.ponto.marcacoes" 
                                    :key="m.index" :title="m.dataHora"></i>
                            </div>		
                            <div style="height: 40px;" 
                                class="p-pt-4 p-d-flex p-jc-center" 
                                :class="slotProps.data.sab.selecionado ? 'div-selecionada' : ''"
                                v-else></div>	
                        </div>			
                    </template>
                </Column>
            </DataTable> 
        </div>
        <div class="p-col-12 p-lg-5" v-if="pontoSelecionado">            
            <div class="card">
                <h5 class="p-mb-5">Ponto {{ formatarDataPtBr(pontoSelecionado.dia) }}</h5>  
                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-mb-4" v-if="pontoSelecionado.marcacoes.length > 0">
                        <i class="pi pi-clock"></i> <label class="p-ml-2">Marcações</label>
                        <hr>          
                        <span v-for="m in pontoSelecionado.marcacoes" :key="m.index" class="ik-text-success p-text-bold">
                            {{ m.dataHora.split(' ')[1] }}
                        </span>
                    </div>  
                    <div class="p-col-12 p-mb-4" v-if="pontoSelecionado.horasFaltantes">
                        <i class="pi pi-minus-circle"></i> <label class="p-ml-2">Horas Faltantes</label>
                        <hr>
                        <span class="ik-text-danger p-text-bold">-{{ pontoSelecionado.horasFaltantes }}</span>
                    </div>
                    <div class="p-col-12 p-mb-4" v-if="pontoSelecionado.divergencias.length > 0">
                        <i class="pi pi-thumbs-down"></i> <label class="p-ml-2">Ocorrências</label>
                        <hr>
                        <span v-for="diverg in pontoSelecionado.divergencias" :key="diverg.id" class="ik-text-danger p-text-bold">
                            {{ diverg.descricao.replace(new RegExp('[0-9][0-9]:[0-9][0-9]'), '') }}
                        </span>
                    </div>
                    <div class="p-col-12" v-if="pontoSelecionado.observacao">
                        <i class="pi pi-info-circle"></i> <label class="p-ml-2">Observação</label>
                        <hr>
                        <span>{{ pontoSelecionado.observacao }}</span>
                    </div>
                    <div class="p-col-12 p-mt-5" v-if="pontoSelecionado">                        
                        <Button label="Justificar Ponto" icon="pi pi-check" 
                            class="p-button-primary p-mr-2" style="width: 160px;" @click="exibirJustificarPonto" 
                            v-if="temJustificarPonto && pontoSelecionado.divergencias.length > 0"/>
                        <Button label="Incluir Marcação" icon="pi pi-clock" 
                            class="p-button-primary" style="width: 160px;" 
                            v-if="temIncluirMarcacao"
                            @click="exibirIncluirMarcacao"/>
                    </div> 
                </div>               
            </div>
        </div>
        <div class="p-col-12 p-lg-5" v-else-if="temResumoHoras">
            <div class="card">
                <h5>Resumo</h5>
                <div v-if="temDadoResumo">
                    <div class="p-col-12 p-lg-12" v-for="item in itensResumo"  v-bind:key="item.nome">     
                        <div class="p-d-flex p-jc-between">
                            <span>{{ item.nome }}</span>
                            <span :class=getClassResumo(item.valor)>{{ item.valor }}</span>
                        </div>      
                    </div>
                </div>        
                <div class="p-d-flex p-jc-center" v-else>
                    <div class="p-col-12 p-lg-12">
                        <div class="p-d-flex p-jc-center p-mb-4">
                            <i class="pi pi-search-minus ik-text-secondary p-mt-5" style="font-size: 8rem"></i>
                        </div>
                        <div class="p-d-flex p-jc-center">
                            <h4 class="ik-text-secondary">Nenhuma informação encontrada</h4>
                        </div>
                    </div>
                </div> 
            </div> 
        </div>
        <solicitacao ref="formIncluirSolicitacao"/>
        <comprovante ref="formComprovantes"/>
    </div>
</template>
  
<script>
import PontoService from '@/service/PontoService';
import Solicitacao from '@/components/pages/espelho/Solicitacao.vue';
import Comprovante from '@/components/pages/espelho/Comprovante.vue';
import { mapGetters, mapActions } from 'vuex';
import { exibirMensagem, localeCalendarBR} from '@/global';
  
export default {
    pontoService: null,
    data() {
        return {
            localeCalendarBR: localeCalendarBR,
            mesAno: new Date(),          
            rangeData: '',
            pontoSelecionado: null,
            temDadoResumo: false,
            justificativasGerais:[],
            justificativasMarcacoes: [],
            semanasDoMes: [],
            itensResumo: [],
            temResumoHoras: false,
            temJustificarPonto: false,
            temIncluirMarcacao: false,
        }
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario']),
        ...mapActions('sessao', ['limparSessao']),        
        /**
         * 
         */
        getEspelho() {            
            let hoje = new Date();
            if(hoje.getFullYear() == this.mesAno.getFullYear() 
                && hoje.getMonth() == this.mesAno.getMonth()) {
                this.mesAno = hoje;
            }
            let requisicao = {
                id: this.getUsuario().id,
                grupo: this.getUsuario().grupo,
                mes: this.mesAno.getMonth() + 1,
                ano: this.mesAno.getFullYear(),
                tipoDispositivo: 'Web'
            }
            this.pontoService.espelho(requisicao)
            .then(resp => {
                let index = 0;
                resp.data.pontos.forEach(ponto => {
                    let marcacoes = [];
                    ponto.marcacoes.forEach(marcacao => {
                        marcacoes.push({ dataHora: marcacao, index: index });
                        index++;
                    });
                    ponto.marcacoes = marcacoes;
                });
                this.justificativasGerais = resp.data.justificativasGerais;
                this.justificativasMarcacoes = resp.data.justificativasMarcacoes;
                this.atualizarResumo(resp.data.resumo);
                this.atualizarEspelho(resp.data);
            })
            .catch(erro => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                }            
            });         
        },
        /**
         * 
         */
        exibirIncluirMarcacao() {
            this.$refs.formIncluirSolicitacao
            .exibirIncluirMarcacao(this.pontoSelecionado, this.mesAno, this.justificativasMarcacoes);
        },
        /**
         * 
         */
        exibirJustificarPonto() {
            this.$refs.formIncluirSolicitacao
            .exibirJustificarPonto(this.pontoSelecionado, this.mesAno, this.justificativasGerais);
        },
        /**
         * 
         */
        exibirDownloadComprovantes() {
            this.$refs.formComprovantes.exibir();
        },
        /**
         * 
         */
        atualizarEspelho(dados) {
            let pontos = this.ajustarCalendarioPonto(dados);
            this.semanasDoMes = [];            
            let diaDS = this.criarDiaDaSemana();
            let novaLinha = false;
            pontos.forEach((ponto, index) => {             
                let arrData = ponto.dia.split('-');
                let data = new Date(Number(arrData[0]), (Number(arrData[1])-1), Number(arrData[2]));
                let dia = data.getDay();
                if(index == 0) {               
                    this.semanasDoMes.push(diaDS)                          
                } else if(novaLinha) {
                    diaDS = this.criarDiaDaSemana();  
                    this.semanasDoMes.push(diaDS) 
                    novaLinha = false;
                }           
                if(dia == 0) {
                    this.setDadosDiaDaSemana(diaDS, ponto, arrData[2], data, 'dom');
                } else if(dia == 1) {
                    this.setDadosDiaDaSemana(diaDS, ponto, arrData[2], data, 'seg');
                } else if(dia == 2) {
                    this.setDadosDiaDaSemana(diaDS, ponto, arrData[2], data, 'ter');
                } else if(dia == 3) {
                    this.setDadosDiaDaSemana(diaDS, ponto, arrData[2], data, 'qua');
                } else if(dia == 4) {
                    this.setDadosDiaDaSemana(diaDS, ponto, arrData[2], data, 'qui');
                } else if(dia == 5) {
                    this.setDadosDiaDaSemana(diaDS, ponto, arrData[2], data, 'sex');
                } else if(dia == 6) {
                    novaLinha = true;
                    this.setDadosDiaDaSemana(diaDS, ponto, arrData[2], data, 'sab');
                }                            
            });
        },
        /**
         * 
         */
        ajustarCalendarioPonto(dados) {            
            let pontos = dados.pontos; 
            if(pontos.length == 0) {
                return this.criarCalendario(dados);
            }
            let umDia = 86400000; 
            let timeInicio = this.converterStrDateParaDate(dados.dataInicio).getTime();   
            let timeFinal = this.converterStrDateParaDate(dados.dataFinal).getTime();  
            for(let i = 0; i < 31; i++) {
                let encontrou = false;                
                let qtdPontos = pontos.length;
                for(let j = 0; j < qtdPontos; j++) {
                    let timePonto = this.converterStrDateParaDate(pontos[j].dia).getTime();
                    if(timeInicio == timePonto) { 
                        encontrou = true;
                        break;                      
                    }    
                }
                if(!encontrou && timeInicio <= timeFinal) {
                    pontos.push(this.criarPontoDia(this.formatarData(new Date(timeInicio))));     
                }      
                timeInicio += umDia;      
            }
            return pontos;
        },
        /**
         * 
         */
        criarCalendario(dados) {
            let timeInicio = this.converterStrDateParaDate(dados.dataInicio).getTime();   
            let timeFinal = this.converterStrDateParaDate(dados.dataFinal).getTime();
            let pontos = [];
            let umDia = 86400000;
            while(timeInicio <= timeFinal) {
                pontos.push(this.criarPontoDia(this.formatarData(new Date(timeInicio))));
                timeInicio += umDia;
            }
            return pontos;
        },
        /**
         * 
         */
        selecilecionarHoje() {
            let semana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'];
            let hoje = new Date();
            let strDateHoje = this.formatarData(hoje);
            if(hoje.getFullYear() == this.mesAno.getFullYear() 
                && hoje.getMonth() == this.mesAno.getMonth()) {
                for(let i = 0; i < this.semanasDoMes.length; i++) {
                    let ddsm = this.semanasDoMes[i][semana[hoje.getDay()]]
                    if(ddsm.data == strDateHoje) {
                        this.selecionarDia(ddsm);
                        break;
                    }
                }
            } else {
                this.mesAno = new Date();
                this.getEspelho();
            }
        },
        /**
         * 
         */
        selecionarResumo() {
            this.pontoSelecionado = null;
        },
        /**
         * 
         */
         selecionarDia(diaDaSemana) {
            let semana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'];
            this.semanasDoMes.forEach(semanaDoMes => {
                semana.forEach(ds => {
                    if(diaDaSemana.data && diaDaSemana.ponto.id) {
                        if(semanaDoMes[ds].data == diaDaSemana.data) {
                            semanaDoMes[ds].selecionado = true;
                            this.pontoSelecionado = diaDaSemana.ponto;
                        } else {
                            semanaDoMes[ds].selecionado = false;
                        }
                    }                    
                });                
            }); 
        },        
        /**
         * 
         */
        getClassStatusDia(dia) {       
            if(dia.atual && dia.selecionado) {                              
                return 'p-text-bold ik-text-success div-selecionada';
            }
            if(dia.atual) {
                return 'p-text-bold ik-text-success';
            }
            if(dia.selecionado) {
                if(dia.ponto && dia.ponto.irregular) {
                    return 'p-text-bold ik-text-danger div-selecionada';
                }
                return 'p-text-bold ik-text-info div-selecionada';
            }
            if(dia.ponto && dia.ponto.irregular) {
                    return 'p-text-bold ik-text-danger';
            }
            return 'ik-text-secondary';
        },        
        /**
         *         
         */
        setDadosDiaDaSemana(semana, ponto, dia, data, nomeDia) {
            semana[nomeDia].dia = dia;           
            semana[nomeDia].ponto = ponto;
            semana[nomeDia].data = this.formatarData(data);
            if(data.toLocaleDateString('pt-br') == this.mesAno.toLocaleDateString('pt-br')) {
                semana[nomeDia].selecionado = true;
                semana[nomeDia].atual = true;
                this.pontoSelecionado = ponto;
            }
        },
        /**
         * 
         */
        criarDiaDaSemana() {
            return { 
                dom: { ponto: null, dia: '',  data: '', atual: false, selecionado: false },
                seg: { ponto: null, dia: '',  data: '', atual: false, selecionado: false },
                ter: { ponto: null, dia: '',  data: '', atual: false, selecionado: false },
                qua: { ponto: null, dia: '',  data: '', atual: false, selecionado: false },
                qui: { ponto: null, dia: '',  data: '', atual: false, selecionado: false },
                sex: { ponto: null, dia: '',  data: '', atual: false, selecionado: false },
                sab: { ponto: null, dia: '',  data: '', atual: false, selecionado: false }        
            };
        },
        /**
         * 
         */
        criarPontoDia(data) {
            return {
                id: '',
                dia: data,
                horasFaltantes: '',
                irregular: false,
                observacao: '',
                marcacoes: [],
                divergencias: []
            };
        },
        /**
        *  
        */
        atualizarResumo(resumo) {        
            this.itensResumo = [];
            this.itensResumo.push({ nome: 'Horas Trabalhadas (H)', 
                valor: (resumo.horasTrabalhadas ? resumo.horasTrabalhadas : '') }
            );
            this.itensResumo.push({ nome: 'Horas Extras (H)', 
                valor: (resumo.horasExtras ? resumo.horasExtras : '') }
            );
            this.itensResumo.push({ nome: 'Banco de Horas (H)', 
                valor: (resumo.saldoBancoHoras ? resumo.saldoBancoHoras : '') }
            );
            this.itensResumo.push({ nome: 'Adicional Noturno (H)', 
                valor: (resumo.adicionalNoturno ? resumo.adicionalNoturno : '') }
            );
            this.itensResumo.push({ nome: 'Atraso (Qtd.)', 
                valor: (resumo.atrasos == 0 ? '' : resumo.atrasos) }
            );
            this.itensResumo.push({ nome: 'Falta (Qtd.)', 
                valor: (resumo.faltas == 0 ? '' : resumo.faltas) }
            );
            this.itensResumo.push({ nome: 'Falta de Marcação (Qtd.)', 
                valor: (resumo.faltasMarcacoes == 0 ? '' : resumo.faltasMarcacoes) }
            );
            this.itensResumo.push({ nome: 'Saída Antecipada (Qtd.)', 
                valor: (resumo.saidasAntecipadas == 0 ? '' : resumo.saidasAntecipadas) }
            ); 
            this.itensResumo.push({ nome: 'Excesso no Intervalo da Refeição (Qtd.)', 
                valor: (resumo.excessosIntervaloRefeicao == 0 ? '' : resumo.excessosIntervaloRefeicao) }
            );
            let qtdComValor = 0;
            this.itensResumo.forEach(item => {
                if(item.valor) {
                qtdComValor++;
                }
            });
            if(qtdComValor > 0) {
                this.temDadoResumo = true;
            }
        }, 
        /**
         *       
         */
        getClassResumo(valor) {
            let cssClass = '';
            if(valor.toString().includes(':')) {
                cssClass = 'ik-badge-resumo-success';
                if(valor.startsWith('-')) {
                cssClass = 'ik-badge-resumo-danger';
                }
            } else if(valor > 0) {
                cssClass = 'ik-badge-resumo-danger';          
            }
            return cssClass;
        },
        /**
         * 
         */
         converterStrDateParaDate(strDate) {
            let arrData = strDate.split('-');
            return new Date(Number(arrData[0]), (Number(arrData[1])-1), Number(arrData[2]));  
        },
        /**
         * 
         */
        formatarData(data) {
            if(!data) {
                return null;
            }
            let strData = null;
            if(data instanceof Date) {
                let dt = data;
                let mes = dt.getMonth();
                let dia = dt.getDate();
                strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
            } else {
                let partes = data.split('/');
                strData = partes[2] + '-' + partes[1] + '-' + partes[0];
            }
            return strData;
        },
        /**
         * 
         */
        formatarDataPtBr(data) {
            let partes = data.split('-');
            return partes[2] + '/' + partes[1] + '/' + partes[0];
        },
        /**
         * 
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-40)+':'+(anoAtual+1);     
        }, 
        /**
         * 
         */
        logout() {
            this.limparSessao();			
            this.$router.push('/login?exp=sessao_expirada');
        }         
    },
    created() { 
        this.criarRangeData();
        let usu = this.getUsuario(); 
        this.temResumoHoras = usu.permissoes.relatorioHoras;
        this.temIncluirMarcacao = usu.permissoes.incluirMarcacao;
        this.temJustificarPonto = usu.permissoes.justificarPonto;
        this.pontoService = new PontoService();   
        this.getEspelho();         
    },
    components: {
        Solicitacao,
        Comprovante
    }
}
</script>
  
<style>
    #espelho th {
        text-align: center !important;
    }   
    #espelho td:hover {
        background-color: #f2f2f2;
        cursor: pointer;
    } 
    .div-selecionada {
        text-align: center;
        background-color: #f2f2f2;
    }       
</style>